/** Race around `promise` to force resolving after `timeoutMS` ms. If the promise takes more
 * time, `withTimeLimit` will either resolve or reject depending on `timeoutAsError`.
 * `withTimeLimit` will reject if `promise` rejects before timing out.
 *
 * Note: even if the function times out `promise` will still continue its execution
 * in the background.
 *
 * @param {PromiseLike<T>|T|Promise<*>} promise
 * @param timeoutMs
 * @param timeoutAsError
 */
export default async function withTimeLimit(promise, timeoutMs = 1000, timeoutAsError = false) {
  if (timeoutMs <= 0) {
    return promise;
  }
  const timeoutPromise = new Promise((resolve, reject) => {
    setTimeout(() => {
      if (timeoutAsError) {
        reject(new Error(`Amplitude flush took too long (timeout=${timeoutMs})`));
      } else {
        resolve("timeout");
      }
    }, timeoutMs);
  });
  // Promise.race ensure that timeout rejection are not reported,
  // even though the timer will resolve/reject in the background.
  return Promise.race([timeoutPromise, promise]);
}
